<template>
  <div>
    <i class="fas fa-info-circle"></i> {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/common/table/no-data.vue